<template>
  <div class='mt-4 flex flex-col gap-3 sm:flex-row sm:items-end sm:gap-4'>
    <div
      v-if='showNameInput'
      class='w-full sm:w-64'
    >
      <StringField
        v-model='internalMethodName'
        name='methodName'
        label='Method name'
        :field='{ mandatory: true }'
        :edit-mode='true'
        :error='nameError'
      />
    </div>
    <div
      v-if='showCodeInput'
      class='w-full sm:max-w-xs'
    >
      <StringField
        v-model='internalCode'
        name='verificationCode'
        :label='codeLabel'
        :field='{ mandatory: true }'
        :edit-mode='true'
        :error='codeError'
        @keydown.enter='$emit("submit")'
      />
    </div>
    <button
      type='button'
      class='h-10 rounded border border-transparent bg-gray-700 px-4 text-sm font-semibold text-white transition hover:bg-gray-600 disabled:cursor-not-allowed disabled:opacity-60 sm:ml-auto'
      :disabled='!canSubmit'
      @click='$emit("submit")'
    >
      {{ submitLabel }}
    </button>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { StringField } from '@/components/inputs'

  const props = defineProps<{
    showNameInput: boolean;
    showCodeInput: boolean;
    methodName: string;
    code: string;
    nameError: string[] | null;
    codeError: string[] | null;
    canSubmit: boolean;
    isConfigureAction: boolean;
    sending: boolean;
  }>()
  const emit = defineEmits<{(e: 'update:methodName', value: string): void; (e: 'update:code', value: string): void; (e: 'submit'): void }>()

  const internalMethodName = computed({
    get: () => props.methodName,
    set: (value: string) => emit('update:methodName', value),
  })

  const internalCode = computed({
    get: () => props.code,
    set: (value: string) => emit('update:code', value),
  })

  const codeLabel = computed(() => props.isConfigureAction ? 'Confirmation code' : 'Verification code')
  const submitLabel = computed(() => {
    if (props.sending) {
      return props.isConfigureAction ? 'Adding...' : 'Submitting...'
    }

    return props.isConfigureAction ? 'Add method' : 'Verify'
  })

</script>
